// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  accountKey: __t.string().primaryKey().name("account_key"),
  bankId: __t.u64().name("bank_id"),
  identity: __t.identity(),
  scaled: __t.f64(),
  netDeposited: __t.i64().name("net_deposited"),
  openedAt: __t.timestamp().name("opened_at"),
  lastActivityAt: __t.timestamp().name("last_activity_at"),
});
